export default __webpack_public_path__ + "static/media/loading.d43f408e.gif";